export default function Field(props) {
  return (
    <input
      {...props}
      className={`w-full rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 px-4 py-3 text-[15px] text-slate-900 dark:text-slate-100 shadow-sm placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-500 dark:focus:ring-emerald-400/30 dark:focus:border-emerald-400 transition-all duration-200 ${
        props.className || ""
      }`}
    />
  );
}
